import React, {useEffect, useState} from 'react';
import {getMostActiveAgencies} from "../../../../models/agency";
import {isEmpty} from "@helpers/helpers";
import AgencyBannerPromote from "./agency_banner_promote";
import AgenciesSlider from "../../../molecules/agency/agencies_slider";

const MostActiveAgencies = ({className, setContactInfo, city_id, district_id = [], count = 12, sectionTitle = null}) => {
    const [agencies, setAgencies] = useState([]);

    useEffect(() => {
        getMostActiveAgencies(city_id, district_id, count).then(result => {
            if (!isEmpty(result) && result.agencies && result.agencies.length) {
                setAgencies(result.agencies)
            } else {
                const agencyBannerPromoteSection = document.querySelector('.js-most-active-agency-section');

                if (!isEmpty(agencyBannerPromoteSection)) {
                    agencyBannerPromoteSection.remove();
                }
            }
        })
    }, [city_id]);

    if (agencies.length === 1) {
        return <AgencyBannerPromote
            agency={agencies[0]}
            className={className}
            setContactInfo={setContactInfo}
            sectionTitle={sectionTitle}
        />
    } else if (agencies.length) {
        return <AgenciesSlider
            agencies={agencies}
            className={className}
            setContactInfo={setContactInfo}
            sectionTitle={sectionTitle}
        />
    }

    return '';
};

export default React.memo(MostActiveAgencies);
